// exclude-from-index
import React, { Component } from 'react';

import { ThemeProvider } from 'styled-components';
import Text from '../../../../../BuildingBlocks/Text';
import FormElements from '../../../../../FormElements/FormElements';
import Grid from '../../../../../Utility/Grid';

import Styled from './FiltersContent.styles';

import { labels as defaultLabels, getLabel } from '../FiltersContainer.seed';
import { LABEL } from '../FiltersContainer.constants';

export default class FiltersContainerMobileFiltersPanel extends Component {
  static defaultProps = {
    labels: defaultLabels,
    propertyTypes: [
      {
        label: 'Hotels',
        icon: 'facilities',
        layerId: '700',
        selected: true
      },
      {
        label: 'Lodges',
        icon: 'facilities',
        layerId: 800,
        selected: true
      }
    ],
    distance: 50,
    distanceUnitBefore: '',
    distanceUnitAfter: 'km',
    location: 'Location',
    distanceMin: 0,
    distanceMax: 200,
    priceRangeMin: 50,
    priceRangeMax: 1000,
    priceRangeSliderMin: 0,
    priceRangeSliderMax: 3000,
    priceRangeStartIcon: '$',
    priceRangeEndIcon: undefined,
    amenities: [],
    shouldInstantBook: false,
    showSeeMore: false,
    hideInstantBook: false,

    onInstantBookToggle: () => {},
    onAmenityClick: () => {},
    onSeeMoreClick: () => {},
    onPriceRangeChangeSlider: () => {},
    onPriceRangeChangeInput: () => {},
    onDistanceChangeSlider: () => {},
    onDistanceChangeInput: () => {},
    onPropertyClick: () => {},

    distanceProps: {}
  };

  handlePropertyTypeClick = layerId => () => {
    const { onPropertyClick } = this.props;
    if (onPropertyClick) {
      onPropertyClick(layerId);
    }
  };

  handleAmenityClick = layerId => () => {
    const { onAmenityClick } = this.props;
    if (onAmenityClick) {
      onAmenityClick(layerId);
    }
  };

  renderPropertyTypesSection = () => {
    const { propertyTypesDescription, propertyTypeTitle } = LABEL;
    const { propertyTypes, labels } = this.props;

    return (
      <Styled.Section divider>
        <Text.HeadingFourth weight="bold">{getLabel(labels, propertyTypeTitle)}</Text.HeadingFourth>
        <Text.CopyParagraph>{getLabel(labels, propertyTypesDescription)}</Text.CopyParagraph>
        <Styled.MapButtonContainer>
          {propertyTypes.map(({ label, icon, layerId, selected }) => (
            <Styled.MapButton
              onClick={this.handlePropertyTypeClick(layerId)}
              selected={selected}
              icon={icon}
              label={label}
              key={layerId}
              fullWidth
            />
          ))}
        </Styled.MapButtonContainer>
      </Styled.Section>
    );
  };

  renderAmenitiesSection = () => {
    const { amenitiesTitle, amenitiesDescription, seeMoreLabel } = LABEL;
    const { amenities, showSeeMore, onSeeMoreClick, labels } = this.props;

    return (
      <Styled.Section divider>
        <Text.HeadingFourth weight="bold">{getLabel(labels, amenitiesTitle)}</Text.HeadingFourth>
        <Text.CopyParagraph>{getLabel(labels, amenitiesDescription)}</Text.CopyParagraph>
        <Styled.MapButtonContainer wrapChildren>
          {amenities.map(({ label, icon, layerId, selected }) => (
            <Styled.MapButton
              onClick={this.handleAmenityClick(layerId)}
              selected={selected}
              icon={icon}
              label={label}
              key={label}
            />
          ))}
        </Styled.MapButtonContainer>
        {showSeeMore && (
          <Styled.SeeMoreContainer>
            <ThemeProvider theme={{ type: 'white' }}>
              <Styled.SeeMore onClick={onSeeMoreClick}>{getLabel(labels, seeMoreLabel)}</Styled.SeeMore>
            </ThemeProvider>
          </Styled.SeeMoreContainer>
        )}
      </Styled.Section>
    );
  };

  renderInstantBookSection = () => {
    const { instantBookTitle, instantBookDescription } = LABEL;
    const { onInstantBookToggle, shouldInstantBook, labels, hideInstantBook } = this.props;

    return (
      !hideInstantBook && (
        <Styled.Section divider>
          <Text.HeadingFourth weight="bold">{getLabel(labels, instantBookTitle)}</Text.HeadingFourth>
          <Grid.Row nogutter>
            <Grid.Col sm={10}>
              <Text.CopyParagraph>{getLabel(labels, instantBookDescription)}</Text.CopyParagraph>
            </Grid.Col>
            <Grid.Col sm={2}>
              <FormElements.Switch checked={shouldInstantBook} onChange={onInstantBookToggle} />
            </Grid.Col>
          </Grid.Row>
        </Styled.Section>
      )
    );
  };

  render() {
    return (
      <>
        {this.renderPropertyTypesSection()}
        {this.renderAmenitiesSection()}
        {this.renderInstantBookSection()}
      </>
    );
  }
}
